module.exports = __webpack_public_path__ + "static/img/eye_white.cbcded64.gif";